// package: eshop
// file: eshop/BasketService.proto

var eshop_BasketService_pb = require("../eshop/BasketService_pb");
var eshop_Basket_pb = require("../eshop/Basket_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var Basket = (function () {
  function Basket() {}
  Basket.serviceName = "eshop.Basket";
  return Basket;
}());

Basket.ProductInfo = {
  methodName: "ProductInfo",
  service: Basket,
  requestStream: false,
  responseStream: false,
  requestType: eshop_Basket_pb.ProductInfoRequest,
  responseType: eshop_Basket_pb.ProductInfoReply
};

Basket.DigitalProductInfo = {
  methodName: "DigitalProductInfo",
  service: Basket,
  requestStream: false,
  responseStream: false,
  requestType: eshop_Basket_pb.DigitalProductInfoRequest,
  responseType: eshop_Basket_pb.DigitalProductInfoReply
};

Basket.PlaceOrder = {
  methodName: "PlaceOrder",
  service: Basket,
  requestStream: false,
  responseStream: false,
  requestType: eshop_Basket_pb.PlaceOrderRequest,
  responseType: eshop_Basket_pb.PlaceOrderReply
};

Basket.OrderSummary = {
  methodName: "OrderSummary",
  service: Basket,
  requestStream: false,
  responseStream: true,
  requestType: eshop_Basket_pb.OrderSummaryRequest,
  responseType: eshop_Basket_pb.OrderSummaryReply
};

Basket.ValidateEmail = {
  methodName: "ValidateEmail",
  service: Basket,
  requestStream: false,
  responseStream: false,
  requestType: eshop_Basket_pb.ValidateEmailRequest,
  responseType: eshop_Basket_pb.ValidateEmailReply
};

Basket.ValidateDiscount = {
  methodName: "ValidateDiscount",
  service: Basket,
  requestStream: false,
  responseStream: false,
  requestType: eshop_Basket_pb.ValidateDiscountRequest,
  responseType: eshop_Basket_pb.ValidateDiscountReply
};

exports.Basket = Basket;

function BasketClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

BasketClient.prototype.productInfo = function productInfo(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Basket.ProductInfo, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BasketClient.prototype.digitalProductInfo = function digitalProductInfo(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Basket.DigitalProductInfo, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BasketClient.prototype.placeOrder = function placeOrder(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Basket.PlaceOrder, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BasketClient.prototype.orderSummary = function orderSummary(requestMessage, metadata) {
  var listeners = {
    data: [],
    end: [],
    status: []
  };
  var client = grpc.invoke(Basket.OrderSummary, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

BasketClient.prototype.validateEmail = function validateEmail(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Basket.ValidateEmail, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

BasketClient.prototype.validateDiscount = function validateDiscount(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(Basket.ValidateDiscount, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.BasketClient = BasketClient;

